import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import { ROUTES } from '../helpers/constants';
import MenuBurgerIcon from '../assets/menu-burger-icon';

export const navLinks = [
  { href: ROUTES.home, title: 'Beranda' },
  // { href: ROUTES.trans_node, title: 'Simpul Transportasi' },
  { href: ROUTES.cctv_online, title: 'CCTV Online', external: true },
  { href: ROUTES.traffic, title: 'Lalu Lintas' },
  { href: ROUTES.complaint, title: 'Pengaduan' },
  { href: ROUTES.trans_schedule, title: 'Jadwal Angkutan' },
  { href: ROUTES.tour, title: 'Wisata' }
];

const Navbar = () => {
  const [active, setActive] = useState(ROUTES.home);
  const [toggle, setToggle] = useState(false);
  const location = useLocation();
  const parentPath = location.pathname.split('/');
  const isScheduleNav = parentPath[1] === ROUTES.trans_schedule.replace('/', '');
  const navBgColor = isScheduleNav ? 'bg-primary-500' : 'bg-white';
  const navScheduleActiveTextColor = (href) =>
    active === href ? 'text-secondary-500' : 'text-white';
  const otherNavScheduleActiveTextColor = (href) =>
    active === href ? 'text-primary-500' : 'text-black';

  useEffect(() => {
    setActive(location.pathname);
  }, [location]);

  const onClickHandler = (nav) => () => {
    if (nav.external) return;
    window.scrollTo(0, 0);
    if (toggle) setToggle(false);
  };

  return (
    <nav
      className={`${navBgColor} sticky top-0 z-40 shadow flex flex-wrap justify-between items-center mx-auto py-3 px-6 md:px-12`}
    >
      <button
        onClick={() => setToggle(!toggle)}
        type="button"
        className="inline-flex items-center w-10 h-10 justify-center text-sm text-gray-500 rounded-lg lg:hidden focus:outline-none"
      >
        <MenuBurgerIcon color={isScheduleNav ? 'white' : 'black'} />
      </button>
      <Link to={ROUTES.home} onClick={onClickHandler(ROUTES.home)}>
        <img
          src={isScheduleNav ? '/white-logo.png' : '/main-logo.png'}
          alt="logo"
          className="h-16"
        />
      </Link>
      <div className="lg:hidden w-10" />
      <div className={`${!toggle && 'hidden'} w-full lg:block lg:w-auto my-4`}>
        <ul
          className={`flex flex-col gap-4 lg:gap-0 lg:space-x-5 rounded-lg lg:flex-row lg:border-0 ${navBgColor}`}
        >
          {navLinks.map((nav, index) => (
            <Link
              key={nav.href}
              className={`text-left text-xl md:text-base lg:text-xl ${
                isScheduleNav
                  ? navScheduleActiveTextColor(nav.href)
                  : otherNavScheduleActiveTextColor(nav.href)
              }
                                `}
              onClick={onClickHandler(nav)}
              to={nav.href}
              target={nav.external ? '_blank' : '_self'}
            >
              {nav.title}
            </Link>
          ))}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;
